import { get, post, put } from "../utils/api/apiCaller";
import { ENDPOINTS } from "../utils/api/endpoints";
import type { ApiResponse } from "../utils/api/apiClient";

export const getDraws = (projectId: string): Promise<ApiResponse> =>
  get(ENDPOINTS.DRAWS.LIST(projectId));

export const getDraw = (
  projectId: string,
  drawId: string,
): Promise<ApiResponse> => get(ENDPOINTS.DRAWS.DETAIL(projectId, drawId));

export const createDraw = (
  projectId: string,
  data: unknown,
): Promise<ApiResponse> => post(ENDPOINTS.DRAWS.CREATE(projectId), data);

export const updateDraw = (
  projectId: string,
  drawId: string,
  data: unknown,
): Promise<ApiResponse> => put(ENDPOINTS.DRAWS.UPDATE(projectId, drawId), data);

export const submitDraw = (
  projectId: string,
  drawId: string,
): Promise<ApiResponse> => post(ENDPOINTS.DRAWS.SUBMIT(projectId, drawId));

export const approveDraw = (
  projectId: string,
  drawId: string,
  data: unknown,
): Promise<ApiResponse> =>
  post(ENDPOINTS.DRAWS.APPROVE(projectId, drawId), data);

export const rejectDraw = (
  projectId: string,
  drawId: string,
  data: unknown,
): Promise<ApiResponse> =>
  post(ENDPOINTS.DRAWS.REJECT(projectId, drawId), data);

export const cancelDraw = (
  projectId: string,
  drawId: string,
  data: { reason: string },
): Promise<ApiResponse> =>
  post(ENDPOINTS.DRAWS.CANCEL(projectId, drawId), data);

export const getActiveSovLienItems = (
  projectId: string,
  page = 1,
  limit = 10,
  q = "",
): Promise<ApiResponse> =>
  get(ENDPOINTS.DRAWS.ACTIVE_SOV_LIEN_ITEMS(projectId, page, limit, q));

export const saveGcDraw = (
  projectId: string,
  data: unknown,
  publish = false,
  drawId = "",
): Promise<ApiResponse> =>
  post(ENDPOINTS.DRAWS.SAVE(projectId, publish, drawId), data);

export const inviteLienWaiver = (
  projectId: string,
  drawId: string,
  lienWaiverId: string,
): Promise<ApiResponse> =>
  post(ENDPOINTS.DRAWS.INVITE_LIEN_WAIVER(projectId, drawId, lienWaiverId));

export const getOwnerLienItems = (projectId: string): Promise<ApiResponse> =>
  get(ENDPOINTS.DRAWS.LIEN_ITEMS(projectId), undefined, { "x-role": "owner" });

export const getGcLienItems = (projectId: string): Promise<ApiResponse> =>
  get(ENDPOINTS.DRAWS.LIEN_ITEMS(projectId), undefined, { "x-role": "gc" });

export const getDrawTimeline = (
  projectId: string,
  drawId: string,
): Promise<ApiResponse> =>
  get(ENDPOINTS.DRAWS.TIMELINE(projectId, drawId), undefined, {
    "x-role": "admin",
  });

export const getDrawInspection = (
  projectId: string,
  drawId: string,
): Promise<ApiResponse> =>
  get(ENDPOINTS.DRAWS.INSPECTION(projectId, drawId), undefined, {
    "x-role": "admin",
  });

export const getDrawFullDetail = (
  projectId: string,
  drawId: string,
): Promise<ApiResponse> =>
  get(ENDPOINTS.DRAWS.FULL_DETAIL(projectId, drawId), undefined, {
    "x-role": "admin",
  });

export const getOwnerSignaturePendingDraws = (
  projectId: string,
): Promise<ApiResponse> =>
  get(ENDPOINTS.DRAWS.OWNER_SIGNATURE_PENDING(projectId));

export const getOwnerDraws = (projectId: string): Promise<ApiResponse> =>
  get(ENDPOINTS.DRAWS.LIST(projectId), undefined, { "x-role": "owner" });

export const ownerSignDraw = (
  projectId: string,
  drawId: string,
  data: unknown,
): Promise<ApiResponse> =>
  post(ENDPOINTS.DRAWS.OWNER_SIGN(projectId, drawId), data, {
    "x-role": "owner",
  });
